import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import {
  EstatusField,
  LoadingWidget,
  TiposEntidadesField,
} from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveEntidadesAction } from '../EntidadesAction';

const FormEntidades = ({ isAjustes = false, setOpenModalForm = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const activo = entidadesStore.activo;

  const initData = {
    nombre: '',
    subtitulo: '',
    correo: '',
    codigo: '',
    rif: '',
    telefono: '',
    isAbierto: true,
    tipoEntidad: 'PUBLICA',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    correo: false,
    telefono: false,
    idEstatus: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          telefono: activo.telefono?.numero ?? '',
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);

      let res = await saveEntidadesAction(
        { dispatch, notify },
        activo?.id,
        data,
        entidadesStore.params,
        isAjustes,
      );
      if (res && !isAjustes) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(CONST.nombre.name, e.target.value)
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.subtitulo.name}
            label={CONST.subtitulo.label}
            value={data.subtitulo}
            onChange={(e) =>
              _handleSetDataField(CONST.subtitulo.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.codigo.name}
            label={CONST.codigo.label}
            value={data.codigo}
            onChange={(e) =>
              _handleSetDataField(CONST.codigo.name, e.target.value)
            }
            helperText={dataError.codigo ? validMessage.required : null}
            error={dataError.codigo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.rif.name}
            label={CONST.rif.label}
            value={data.rif}
            onChange={(e) =>
              _handleSetDataField(CONST.rif.name, e.target.value)
            }
            helperText={dataError.rif ? validMessage.required : null}
            error={dataError.rif}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.correo.name}
            required
            label={CONST.correo.label}
            value={data.correo}
            onChange={(e) =>
              _handleSetDataField(CONST.correo.name, e.target.value)
            }
            helperText={dataError.correo ? validMessage.required : null}
            error={dataError.correo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.telefono.name}
            required
            label={CONST.telefono.label}
            value={data.telefono}
            onChange={(e) =>
              _handleSetDataField(CONST.telefono.name, e.target.value)
            }
            helperText={dataError.telefono ? validMessage.required : null}
            error={dataError.telefono}
          />
          <Typography variant="caption" color="grey">
            Ejemplo: +584241112233
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.isAbierto}
                onChange={(e) => {
                  _handleSetDataField(CONST.isAbierto.name, e.target.checked);
                }}
              />
            }
            label="La entidad se encuentra operativa"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {loginStore.isRoot ? (
            <TiposEntidadesField
              value={data.tipoEntidad}
              onChange={(e) => {
                _handleSetDataField(CONST.tipoEntidad.name, e.target.value);
              }}
            />
          ) : (
            <Typography variant="body1" color="initial">
              <strong>Tipo de Entidad:</strong>
              <br />
              {data.tipoEntidad}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={12}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            loading={loadingSave}
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            mr={2}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntidades;
